module.exports = __webpack_public_path__ + "static/media/img_2.fef459c2.jpg";